import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

/**
 * Group Booking — name popup shown when the operator picks "Create new
 * group…" from the appointment right-click menu. Anchors a new same-day
 * group on the selected appointment's customer as the Primary Payer.
 */
export default function GroupNameDialog({ open, appt, name, setName, onSubmit, onClose }) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-sm" data-testid="group-name-dialog">
        <DialogHeader>
          <DialogTitle>Create Group</DialogTitle>
          <DialogDescription>
            This will start a new same-day group anchored on{" "}
            <span className="font-medium">{appt?.customer_name || "this guest"}</span> as the Primary Payer.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <label className="text-sm font-medium">Group name</label>
          <Input
            value={name}
            autoFocus
            placeholder="e.g. Smith Family, Bali Retreat 2026"
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") onSubmit(); }}
            data-testid="group-name-input"
          />
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} data-testid="group-name-cancel">Cancel</Button>
          <Button onClick={onSubmit} disabled={!name.trim()} data-testid="group-name-create">Create</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
